import React from "react";
import { useGetProjectFolderInfoQuery } from "./query.hotchoc.generated";
import { Link } from "react-router-dom";
import { project } from "~/routes";
import { InfoLabel } from "./components/InfoLabel";
import { formatFirstMiddleLast } from "~/utils/formatEmployeeName";

type ProjectFolderInfoProps = {
  projectNumber: number;
};

export const ProjectFolderInfo: React.FC<ProjectFolderInfoProps> = ({
  projectNumber,
}) => {
  const { loading, error, data } = useGetProjectFolderInfoQuery({
    variables: { input: { projectNumber: projectNumber } },
  });

  const projectData = data?.projects?.project;

  return loading ? (
    <>
      <InfoLabel>Loading info...</InfoLabel>
    </>
  ) : data && !error ? (
    <>
      <InfoLabel>
        <span>Project Number: </span>
        <Link to={project.toRoute(projectNumber).path}>
          {projectData?.number}
        </Link>
      </InfoLabel>
      <InfoLabel>
        <span>Name: </span>
        <Link to={project.toRoute(projectNumber).path}>
          {projectData?.name}
        </Link>
      </InfoLabel>
      <InfoLabel>
        <span>Location: </span>
        {projectData?.location?.state}-{projectData?.location?.county}
      </InfoLabel>
      <InfoLabel>
        <span>Billing Admin: </span>
        {projectData?.billingAdmin &&
          formatFirstMiddleLast(projectData.billingAdmin)}
      </InfoLabel>
      <InfoLabel>
        <span>Project Manager: </span>
        {projectData?.projectManager &&
          formatFirstMiddleLast(projectData.projectManager)}
      </InfoLabel>
    </>
  ) : (
    <>
      <InfoLabel>Error fetching project info</InfoLabel>
    </>
  );
};
